import { Box } from "../components/legacy-ui/materialCompat";
import React from "react";
import jwt from "jsonwebtoken";

export const UNIVERSAL_AGE_RANGE = 121;

const hasAgeRangeValue = (ageRange) =>
  ageRange !== undefined && ageRange !== null && ageRange !== "";

export const getContentAgeRangeValue = (item) => {
  if (!item || typeof item !== "object") return undefined;

  const ranges = [
    item?.content?.ageRange,
    item?.content?.contentAgeRange,
    item?.contentMeta?.content?.ageRange,
    item?.contentMeta?.content?.contentAgeRange,
    item?.rawData?.ageRange,
    item?.rawData?.contentAgeRange,
    item?.ageRange,
    item?.contentAgeRange,
  ];

  return ranges.find(hasAgeRangeValue);
};

export const isAgeRangeAllowed = (contentAgeRange, profileAgeRange, allowMissing = false) => {
  if (!hasAgeRangeValue(contentAgeRange)) {
    return allowMissing;
  }

  const contentAge = Number(contentAgeRange);
  if (contentAge === UNIVERSAL_AGE_RANGE) {
    return true;
  }

  const profileAge = Number(profileAgeRange);
  if (!Number.isFinite(contentAge) || !Number.isFinite(profileAge)) {
    return false;
  }

  return contentAge <= profileAge;
};

export const isContentItemAllowedForAgeRange = (item, profileAgeRange, allowMissing = false) => {
  const ranges = [
    item?.content?.ageRange,
    item?.content?.contentAgeRange,
    item?.contentMeta?.content?.ageRange,
    item?.contentMeta?.content?.contentAgeRange,
    item?.rawData?.ageRange,
    item?.rawData?.contentAgeRange,
    item?.ageRange,
    item?.contentAgeRange,
  ];
  const hasAnyRange = ranges.some(hasAgeRangeValue);

  if (!hasAnyRange) {
    return allowMissing;
  }

  return ranges.some((ageRange) => isAgeRangeAllowed(ageRange, profileAgeRange));
};

export const getAgeRange = (token) => {
  if (!token) return null;
  try {
    const { ageRange } = jwt.decode(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return null;
  }
};

export const getAgeRangePublicRoute = () => {
  const token = localStorage.getItem("webTvUserToken");

  if (!token) return 120;
  try {
    const { ageRange } = jwt.decode(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return 120;
  }
};

const GetAgeRangeComponent = (ageRange = 0) => {
  switch (Number(ageRange)) {
    case UNIVERSAL_AGE_RANGE:
      return (
        <div
          className={"age-range-universal inline-flex items-center"}
          style={{ color: "#FDC13C", fontSize: 18, lineHeight: 1.35 }}
        >
          <p
            className="font-bold"
            style={{
              color: "inherit",
              fontSize: "inherit",
              lineHeight: "inherit",
              margin: 0,
            }}
          >
            مناسب تمامی سنین
          </p>
        </div>
      );
    case 120:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/18.svg"}
            alt={"مناسب برای بالای 18 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />
          <p className="font-bold">مناسب برای بالای ۱۸ سال</p>
        </div>
      );
    case 18:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/15.svg"}
            alt={"مناسب برای بالای 15 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />

          <p className="font-bold">مناسب برای تا ۱۸ سال</p>
        </div>
      );
    case 13:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/12.svg"}
            alt={"مناسب برای بالای 12 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />
          <p className="font-bold"> مناسب برای تا ۱۳ سال</p>
        </div>
      );
    case 7:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/6.svg"}
            mx={0.5}
            alt={"مناسب برای بالای 6 سال"}
            className={"w-[40px] "}
          />

          <p className="font-bold">مناسب برای زیر 7 سال</p>
        </div>
      );
    default:
      return null;
  }
};

export default GetAgeRangeComponent;
